import type { ReactNode } from 'react';

import { StyledVersionedRouterLink } from 'components/Link/StyledVersionedRouterLink';
import type { I18nFn } from 'i18n/types/I18nFn';

type Args = {
  i18n: I18nFn;
  orgUrl: string | undefined;
  orgPublishedInternshipsCount: number;
};

export function getUnpublishedInternshipPageSeeMoreText({
  i18n,
  orgUrl,
  orgPublishedInternshipsCount,
}: Args): ReactNode {
  if (!orgUrl) {
    return i18n('Search below for an internship title that interests you.');
  }

  const link = (
    <StyledVersionedRouterLink
      to={orgUrl}
      data-qa-id="view-internship-page-unpublished-view-organization-opportunities"
    />
  );

  if (orgPublishedInternshipsCount > 0) {
    return i18n(
      'You can see more {{link}}internships by this organization{{/link}}, or search below',
      { link },
    );
  }

  return i18n(
    'You can learn more about {{link}}the organization that posted this listing{{/link}}, or search below',
    { link },
  );
}
